import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import {
    makeStyles, useTheme, IconButton, Paper, Tabs, Tab } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { themeTypeToBool, getRoutesOfType } from "../../../../utils/helpers";
import { PDFDownloadLink } from '@react-pdf/renderer';
import PdfRouteSummary from '../../../PdfComponents/PdfRouteSummary';
import RouteTab from './RouteTab';
import RefuelTab from './RefuelTab';
import ZoneTab from './ZoneTab';
import WarningTab from './WarningTab';
import { typeRoute, typeZone, typeRefuel, typeWarning } from './../../../../utils/staticData';
import moment from 'moment-timezone';
import t from "../../../../languages/pl";
import { displayDateTimeWithoutSecondsFormat } from "../../../../utils/staticData";
import RoutesSummary from '../../../Common/RoutesSummary';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => ({
    dialogPaper: {
        height: "90vh",
    },
    content: {
        color: themeTypeToBool(theme.palette.type) ? "#000" : "#fff"
    },
    closeButton: {
        position: "absolute",
        top: theme.spacing(1),
        right: theme.spacing(1),
    },
    paper: {
        margin: theme.spacing(1),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    },
    buttonOk: {
        background: themeTypeToBool(theme.palette.type) ? "#43425D" : theme.palette.primary.main
    },
    buttonLabel: {
        color: "#FFF"
    },
    summary: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        marginRight: theme.spacing(3)
    },
    singleSummary: {
        margin: theme.spacing(1),
        color: themeTypeToBool(theme.palette.type) ? "#000" : "#FFD1A4"
    },
    pdfDownloadLink: {
        textDecoration: "none"
    }
}));

function RouteSummaryDialog(props) {
    const theme = useTheme();
    const classes = useStyles(theme);
    const { onClose, open, startDate, endDate, name, routes } = props;
    const [tab, setTab] = useState(0);
    const title = [
        t.routeListInPeriod,
        moment.unix(startDate).format(displayDateTimeWithoutSecondsFormat),
        "-",
        moment.unix(endDate).format(displayDateTimeWithoutSecondsFormat),
        ":",
        name
    ].join(" ");

    const savePdfButton = (content, ready) => {
        return (
            <Button variant="contained"
                color="secondary"
                disabled={!ready}
            >
                {content}
            </Button>
        );
    };

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            open={open}
            TransitionComponent={Transition}
            maxWidth={false}
            keepMounted
            onClose={onClose}
        >
            <DialogTitle>
                {title}
                <IconButton
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Paper className={classes.paper}>
                    <Tabs
                        centered
                        value={tab}
                        onChange={(e, newValue) => setTab(newValue)}
                    >
                        <Tab label={t.routes} value={0} />
                        <Tab label={t.refuels} value={1} />
                        <Tab label={t.zoning} value={2} />
                        <Tab label={t.incidents} value={3} />
                    </Tabs>
                    {tab === 0 && <RouteTab routes={getRoutesOfType(routes, typeRoute)} />}
                    {tab === 1 && <RefuelTab refuels={getRoutesOfType(routes, typeRefuel)} />}
                    {tab === 2 && <ZoneTab zones={getRoutesOfType(routes, typeZone)} />}
                    {tab === 3 && <WarningTab warnings={getRoutesOfType(routes, typeWarning)} />}
                </Paper>
                <div className={classes.summary}>
                    <RoutesSummary
                        routes={routes}
                        typographyClassName={classes.singleSummary}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <PDFDownloadLink
                    document={
                        <PdfRouteSummary
                            title={title}
                            routes={getRoutesOfType(routes, typeRoute)}
                            refuels={getRoutesOfType(routes, typeRefuel)}
                            zones={getRoutesOfType(routes, typeZone)}
                            incidents={getRoutesOfType(routes, typeWarning)}
                        />
                    }
                    className={classes.pdfDownloadLink}
                >
                    {({ loading }) => (
                        loading ? savePdfButton(t.loadingPDF, false) : savePdfButton(t.savePdfToFile, true)
                    )}
                </PDFDownloadLink>

                <Button
                    variant="contained"
                    classes={{ containedPrimary: classes.buttonOk, label: classes.buttonLabel }}
                    onClick={onClose}
                    color="primary"
                >
                    {t.close}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default RouteSummaryDialog;

RouteSummaryDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    name: PropTypes.string,
    startDate: PropTypes.number,
    endDate: PropTypes.number,
    routes: PropTypes.array
};